import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ConnectedUser } from '../../connection/socket';
import { GreenroomState as TS } from '../../stores/types/types';

interface ThumbBadgeProps {
	isScreenShare: boolean
	videoIsOnCanvas: boolean
	videoWebRtcId: string | null // null when restricted
	userObjForFeed?: ConnectedUser // videoMap in video-feed-thumbnail passes undefined user
}

export default function ThumbnailBadge(props: ThumbBadgeProps) {
	const {
		videoIsOnCanvas, userObjForFeed, isScreenShare, videoWebRtcId,
	} = props;

	const onsiteUsers = useSelector((s: TS) => s.SessionReducer.userMeetingSettings.onsiteUsers);
	const sessionWebRtcId = useSelector((s: TS) => s.SessionReducer.webrtcID);
	const sessionIsHost = useSelector((s: TS) => s.SessionReducer.host);

	useEffect(() => {
		if (!userObjForFeed) {
			console.log(`ERROR: No user found in videoMap for webRtcId ${videoWebRtcId}`);
		}
	}, [userObjForFeed]);

	const isOnsiteFeed = useMemo(
		() => onsiteUsers?.includes(userObjForFeed?.gr_user ?? 0),
		[userObjForFeed?.gr_user, onsiteUsers],
	);

	const liveBadge = useMemo(() => {
		if (
			isOnsiteFeed
			|| userObjForFeed?.isProducer
			|| !userObjForFeed
		) {
			return <></>;
		}
		if (props.videoIsOnCanvas) {
			return <div className="live-time-red">
				<div className="live-time-red-dot-full">
					<div className="red-dot"></div>
					<span>LIVE</span>
				</div>
			</div>;
		}
		return <></>;
	}, [userObjForFeed?.isProducer, videoIsOnCanvas, isOnsiteFeed]);

	const prodOnsiteLabel = useMemo(() => {
		if (isScreenShare) { return <></>; }
		if (!userObjForFeed) { return <></>; }
		if (!userObjForFeed.isProducer && !isOnsiteFeed) { return <></>; }

		let text = '';
		if (userObjForFeed?.isProducer && isOnsiteFeed) {
			text = 'PROD-ONSITE';
		} else if (userObjForFeed?.isProducer) {
			text = 'PRODUCER';
		} else if (isOnsiteFeed) {
			text = 'ONSITE';
		}

		return <div className="producer-label">
			<span data-testid="producer-label">{text}</span>
		</div>;
	}, [userObjForFeed?.isProducer, isOnsiteFeed, isScreenShare]);

	const fallbackProducerLabel = useMemo(() => {
		if (
			prodOnsiteLabel === <></>
			&& sessionIsHost
			&& sessionWebRtcId === videoWebRtcId
		) {
			<div className="producer-label" data-testid="producer-label">
				<span>PRODUCER</span>
			</div>;
		}
	}, [sessionIsHost, sessionWebRtcId, videoWebRtcId, prodOnsiteLabel]);

	return (
		<>
			{liveBadge}
			{prodOnsiteLabel}
			{fallbackProducerLabel}
		</>
	);
}
